import { isBefore } from 'date-fns'

const isMatchInThePast = ({ matchEndDate }: { matchEndDate: Date }) => {
  return !isBefore(new Date(), matchEndDate)
}

export default isMatchInThePast
